import { Input, Checkbox, Typography } from "antd"
import { FunctionComponent, ReactNode, useEffect, useState } from "react"
import { GuardianWaiverResponse } from "../ClubSeasonManagement/RegistrationConfiguration/RegistrationHelper"
import {
  IRegistrationWaiverSection
} from "../ClubSeasonManagement/RegistrationConfiguration/RegistrationWaiverSubsection"
import { GuardianWaiverMonitor } from "../Helpers/GuardianWaiverMonitor"
import { ParagraphedText } from "../ui"
import { useRegistrationFormContext } from "./sharedState"
import { StyledWaiver } from "./styles"
import { sanitizeRichTextHtml } from "../utils/sanitizeRichTextHtml"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck, faCircleQuestion, faPenToSquare } from "@fortawesome/free-regular-svg-icons"





type TSingleWaiverSectionProps = {
  section: IRegistrationWaiverSection
  waiverResponses?: Record<string,GuardianWaiverResponse>
  waiverMonitor?: GuardianWaiverMonitor
}

const { TextArea } = Input
const { Text } = Typography



export const SingleWaiverSection: FunctionComponent<TSingleWaiverSectionProps> =
  (  {section, waiverResponses, waiverMonitor} ) => {
    const [freeformResponse, setFreeformResponse] = useState("")
    const [guardianAcknowledged, setGuardianAcknowledged] = useState(false)
    const { previewMode } = useRegistrationFormContext()
 
  useEffect(() => {
    if (waiverResponses !== undefined) {
      const waiverResponse = waiverResponses[`${section.waiverSectionId}`]
      setFreeformResponse(waiverResponse?.freeformResponse ?? "")
      setGuardianAcknowledged(waiverResponse?.guardianAcknowledged ?? false)
    }
  }, [section.waiverSectionId, waiverResponses])

    const agreeBorderColor = guardianAcknowledged ? "#b7eb8f" : "#ffd591"
    const agreeBackgroundColor = guardianAcknowledged ? "#f6ffed" : "#fff7e6"
    const agreeIconColor = guardianAcknowledged ? "#52c41a" : "#faad14"

    const responseProvided = freeformResponse.trim().length > 0
    const responseBorderColor = responseProvided ? "#b7eb8f" : "#ffd591"
    const responseBackgroundColor = responseProvided ? "#f6ffed" : "#fff7e6"
    const responseIconColor = responseProvided ? "#52c41a" : "#faad14"

    return (
      <StyledWaiver >
        <h6>{section.sectionTitle}</h6>
        <div
          className="waiver-section-body"
          dangerouslySetInnerHTML={{
            __html: sanitizeRichTextHtml(section.wording || ""),
          }}
        />
        {section.acknowledgmentRequirement === "text input" && (
          <div
            style={{
              marginTop: 12,
              padding: 12,
              borderRadius: 6,
              border: `1px solid ${responseBorderColor}`,
              backgroundColor: responseBackgroundColor,
              cursor: previewMode ? "default" : "pointer",
            }}
            onClick={() => {
              if (previewMode) return
              const textArea = document.getElementById(
                `waiver-section-text-input-${section.waiverSectionId}`,
              ) as HTMLTextAreaElement | null
              textArea?.focus()
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 8,
                gap: 8,
              }}
            >
              <FontAwesomeIcon
                icon={responseProvided ? faCircleCheck : faCircleQuestion}
                style={{ color: responseIconColor, fontSize: 18 }}
              />
              <Text strong>Your response (required)</Text>
            </div>
            <TextArea
              id={`waiver-section-text-input-${section.waiverSectionId}`}
              disabled={previewMode}
              value={freeformResponse}
              onChange={(e) => {
                const response = e.target.value
                setFreeformResponse(response)
                waiverMonitor?.addResponse(
                  `${section.waiverSectionId}`,
                  undefined,
                  response,
                )
              }}
              autoSize={{ minRows: 3, maxRows: 10 }}
            />
          </div>
        )}
        {section.acknowledgmentRequirement === "mandatory" && (
          <div
            style={{
              marginTop: 12,
              padding: 12,
              borderRadius: 6,
              border: `1px solid ${agreeBorderColor}`,
              backgroundColor: agreeBackgroundColor,
              cursor: previewMode ? "default" : "pointer",
            }}
            onClick={() => {
              if (previewMode) return
              const next = !guardianAcknowledged
              setGuardianAcknowledged(next)
              waiverMonitor?.addResponse(
                `${section.waiverSectionId}`,
                next,
                undefined,
              )
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <FontAwesomeIcon
                icon={guardianAcknowledged ? faCircleCheck : faCircleQuestion}
                style={{ color: agreeIconColor, fontSize: 18 }}
              />
              <Checkbox
                checked={guardianAcknowledged}
                disabled={previewMode}
                onClick={(e) => {
                  e.stopPropagation()
                }}
                onChange={(e) => {
                  const next = e.target.checked
                  setGuardianAcknowledged(next)
                  waiverMonitor?.addResponse(
                    `${section.waiverSectionId}`,
                    next,
                    undefined,
                  )
                }}
                style={{ cursor: previewMode ? "default" : "pointer" }}
              >
                <span
                  style={{
                    fontWeight: 600,
                    cursor: previewMode ? "default" : "pointer",
                  }}
                >
                  I Agree
                </span>
              </Checkbox>
            </div>
          </div>
        )}
      </StyledWaiver>
    )
    
  }
